import {
    Component,
    OnInit,
    Input,
    forwardRef,
    NgModule,
    TemplateRef,
    Output,
    EventEmitter,
    ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { API } from '../services/api';
import { Subject } from 'rxjs/Rx';

export interface GoodOpt {
    name: string;
    goodId?: string;
    disabled?: boolean;
}

export interface DomOpt {
    _value: string;
    _label: string;
}

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GoodSelectComponent),
    multi: true
};
export class GoodSelectComponent implements ControlValueAccessor, OnInit {
     domOpt: DomOpt;
public onTouchedCallback: () => () => {};
public onChangeCallback: (_: any) => () => {};

    options: Array<GoodOpt> = [];
    // 单选的时候传字符串，多选传数组
    _value: string;
    _width = "100%";
    _content: TemplateRef<any>;
    _allowClear = true;
    _nzMode = "combobox";
    // 下拉过滤含关键字选项，false为不过滤
    _filter = false;
    currentText = '';
    firstNum = 0;
    canQuery = true;
    keyWordStream = new Subject<string>()
    keyWord$: any;

     placeholder = "请选择品名";
     rowsNum = 10;
     valueType = "";
/**
 * @param {?} v
 * @return {?}
 */
set value(v: string) {
        if(typeof v === 'string' && v.trim() === '' || !v) {
            this.firstNum = 0;
            this.queryData('', []);
        }
        this._value = v;
        // 双向绑定获取对象
        if (this.valueType === "object") {
            const { _value, _label } = this.domOpt;
            this.onChangeCallback({ value: _value, label: _label });
        } else {
            const /** @type {?} */ innerValue = this._allowClear ? (v || "") : (v || []);
            this.onChangeCallback(innerValue);
        }

    }
/**
 * @return {?}
 */
get value(): string {
        return this._value;
    };
/**
 * @param {?} v
 * @return {?}
 */
set width(v: any) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes("%") ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }
/**
 * @param {?} v
 * @return {?}
 */
set goodMode(v) {
        this._nzMode = v;
        this._allowClear = v === "combobox" ? true : false;
    };
/**
 * @param {?} tpl
 * @return {?}
 */
set customTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._content = tpl;
        }
    }
/**
 * @param {?} api
 */
constructor(private api: API) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        // 限流
        this.keyWord$ = this.keyWordStream
            .debounceTime(250)
            .subscribe(word => {
                this.queryData(word, []);
            });

    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.keyWord$.unsubscribe()
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * @param {?} event
 * @return {?}
 */
yztSearchChange(event) {
        this.canQuery = true;
        this.currentText = event;
        this.firstNum = 0;
        this.keyWordStream.next(event);
    }
/**
 * @return {?}
 */
yztScrollToBottom() {
        this.queryData(this.currentText, this.options);
    }
/**
 * 仅作清空多选选项
 * @param {?=} $event
 * @return {?}
 */
clearSelect($event?: MouseEvent): void {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.options = [];
        this.value = '';
    }
/**
 * 查询数据
 * @param {?=} searchText
 * @param {?=} options
 * @return {?}
 */
queryData(searchText?: string, options?: Array<GoodOpt>) {
        if (!this.canQuery) return;
        const /** @type {?} */ goodName = searchText;
        let /** @type {?} */ pageParms = { "first": this.firstNum, "rows": this.rowsNum };
        this.api.call("abnormalOtherHandleController.waybillGoodsQuery", pageParms, {
            name: goodName
        }).ok(json => {
            const /** @type {?} */ result = json.result && json.result.content || [];
            if (!result.length) {
                const /** @type {?} */ lastItem = new Array<GoodOpt>({ goodId: "empty", name: "没有更多选项！", disabled: true });
                this.options = options.concat(lastItem);
                this.canQuery = false;
                return;
            }
            this.options = options.concat(result);
            this.firstNum += this.rowsNum;
        }).fail(err => {
            throw new Error(err);
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `yzt-good`,
    template: `
    <div class="good-select">
        <nz-select 
            class="good-nz-select"
            [style.width]="_width" 
            [nzPlaceHolder]="placeholder" 
            [nzMode]="_nzMode"
            [nzFilter]="_filter"
            [nzAllowClear]="_allowClear"
            (nzScrollToBottom)="yztScrollToBottom()"
            (nzSearchChange)="yztSearchChange($event)"
            [(ngModel)]="value">
            <nz-option
                #domOpt
                *ngFor="let option of options"
                [nzLabel]="option.name"
                [nzValue]="option.goodId"
                [nzDisabled]="option.disabled">
                <ng-template *ngIf="_content" #nzOptionTemplate>
                    <ng-container [ngTemplateOutlet]="_content" [ngTemplateOutletContext]="option"></ng-container>
                </ng-template>
            </nz-option>
        </nz-select>
        <span
          role="close-icon"
          (click)="clearSelect($event)"
          class="ant-select-selection__clear close-icon"
          style="-webkit-user-select: none;"
          *ngIf="!_allowClear&&options.length">
        </span>
    </div>
    `,
    styles: [`
        .close-icon {
            opacity: 0;
            position: absolute;
            right: 20px;
            top: 50%;
            margin-top: -10px;
        }
        .close-icon:hover {
            opacity: 1;
        }
        .good-nz-select:hover +.close-icon {
            opacity: 1;
        }
        .good-select {
            position: relative;
        }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: API, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'domOpt': [{ type: ViewChild, args: ["domOpt", ] },],
'placeholder': [{ type: Input },],
'rowsNum': [{ type: Input },],
'valueType': [{ type: Input },],
'width': [{ type: Input },],
'goodMode': [{ type: Input },],
'customTemplate': [{ type: Input },],
};
}

function GoodSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
GoodSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GoodSelectComponent.ctorParameters;
/** @type {?} */
GoodSelectComponent.propDecorators;
/** @type {?} */
GoodSelectComponent.prototype.domOpt;
/** @type {?} */
GoodSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
GoodSelectComponent.prototype.onChangeCallback;
/** @type {?} */
GoodSelectComponent.prototype.options;
/** @type {?} */
GoodSelectComponent.prototype._value;
/** @type {?} */
GoodSelectComponent.prototype._width;
/** @type {?} */
GoodSelectComponent.prototype._content;
/** @type {?} */
GoodSelectComponent.prototype._allowClear;
/** @type {?} */
GoodSelectComponent.prototype._nzMode;
/** @type {?} */
GoodSelectComponent.prototype._filter;
/** @type {?} */
GoodSelectComponent.prototype.currentText;
/** @type {?} */
GoodSelectComponent.prototype.firstNum;
/** @type {?} */
GoodSelectComponent.prototype.canQuery;
/** @type {?} */
GoodSelectComponent.prototype.keyWordStream;
/** @type {?} */
GoodSelectComponent.prototype.keyWord$;
/** @type {?} */
GoodSelectComponent.prototype.placeholder;
/** @type {?} */
GoodSelectComponent.prototype.rowsNum;
/** @type {?} */
GoodSelectComponent.prototype.valueType;
/** @type {?} */
GoodSelectComponent.prototype.api;
}

export class GoodSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
    ],
    declarations: [
        GoodSelectComponent
    ],
    exports: [GoodSelectComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GoodSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
GoodSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GoodSelectModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
